module.exports = __webpack_public_path__ + "img/sii-icon-dark.06c5930d.svg";